<template>
  <div>
    <div class="mainWrapper">
      <MainSideBarVue />

      <div class="rightContentWrapper">
        <div class="topNav">
          <TopBarVue />
        </div>

        <div class="innerContainer">
          <div class="theHeaderWrapper">
            <div>
              <i
                @click="$router.go(-1)"
                style="
                  font-size: 25px;
                  font-weight: bold;
                  cursor: pointer;
                  margin-right: 20px;
                "
                class="bi bi-arrow-left"
              ></i>
              Add group talk users
            </div>

            <div class="theRightBox">
   
            </div>
          </div>

          <div class="wizardWrapper" v-if="!teamStore.newUsersAddedToGroupTalkSuccess">

            <table class="table table-borderless table-hover">
              <thead>
                <tr>
                  <th scope="col" class="py-3 text-start">First Name</th>
                  <th scope="col" class="py-3 text-start">Last Name</th>
                  <th scope="col" class="py-3 text-start">Role</th>
                  <th scope="col" class="py-3 text-start">Team</th>
                  <th></th>
                </tr>
              </thead>

              <tbody v-if="teamStore.newGroupTalkUsersArray.length > 0">
                <template
                  v-for="(newUser, index) in teamStore.newGroupTalkUsersArray"
                  :key="index"
                >
                  <!-- MAIN ROW -->
                  <tr
                    :class="
                      newUser.show_error
                        ? 'theTableRowStyleWithError'
                        : 'theTableRowStyle'
                    "
                  >
                    <td class="py-3 text-start" style="width: 300px">
                      <input
                        v-model="newUser.first_name"
                        type="text"
                        class="form-control"
                        required
                      />
                    </td>

                    <td class="py-3 text-start" style="width: 300px">
                      <input
                        v-model="newUser.last_name"
                        type="text"
                        class="form-control"
                        required
                      />
                    </td>

                    <td class="py-3 text-start">
                      <div class="roleBox">
                        <select v-model="newUser.role_type" class="form-select">
                          <option
                            v-for="(role, rIndex) in teamStore.inspectionAppUserRoles"
                            :key="rIndex"
                            :value="role.role_type"
                          >
                            {{ role.name }}
                          </option>
                        </select>
                      </div>
                    </td>

                    <td class="py-6 text-start" style="display: flex">
                      <div>
                        <div
                          @click="teamStore.setCurrentNewGroupTalkUser(newUser)"
                          class="selectSupBox"
                          v-if="newUser.teams.length > 0"
                        >
                          <div v-for="(group, gIndex) in newUser.teams" :key="gIndex">
                            <span
                              class="badge rounded-pill bg-success theSupPill"
                              v-if="group.is_checked == 1"
                            >
                              <i class="bi bi-check-lg"></i>
                              {{ group.name }}
                            </span>

                            <span
                              class="badge rounded-pill bg-light theSupPill"
                              style="color: black"
                              v-if="group.is_checked == 0"
                            >
                              {{ group.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="theCloseBox">
                        <div v-if="teamStore.newGroupTalkUsersArray.length > 1">
                          <i
                            @click="teamStore.deleteANewGroupTalkUserFromArray(index)"
                            class="bi bi-x-lg"
                            style="cursor: pointer"
                          ></i>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- ERROR ROW -->
                  <tr v-if="newUser.show_error">
                    <td colspan="5" style="padding-top: 0">
                      <div style="color: red; font-weight: bold; font-size: 13px">
                        {{ newUser.error_message }}
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>

              <!-- <tbody v-if="teamStore.newGroupTalkUsersArray.length > 0">

                <tr v-for="(newUser, index) in teamStore.newGroupTalkUsersArray" :key="index" 
                :class="newUser.show_error ? 'theTableRowStyleWithError' : 'theTableRowStyle'"
                >

                    

                  <td class="py-3 text-start" style="width: 300px">

                           <input v-model="newUser.first_name" type="text" class="form-control"
                                                        required>

                  </td>


                    <td class="py-3 text-start" style="width: 300px">
                       
                              <input v-model="newUser.last_name" type="text" class="form-control"
                                                        required>
                    </td>

                  <td class="py-3 text-start"> 

                    <div class="roleBox">
                           <select v-model="newUser.role_type" class="form-select">

                                <option v-for="(role, index) in teamStore.inspectionAppUserRoles"
                                :key="index" :value="role.role_type">
                                    {{ role.name }} 
                                </option>

                            </select>
                    </div>

                  </td>

                  <td class="py-6 text-start" style="display: flex">

                    <div>

                      <div @click="teamStore.setCurrentNewGroupTalkUser(newUser)" 
                      class="selectSupBox" v-if="newUser.teams.length > 0">

                        <div v-for="(group, index) in newUser.teams" :key="index">
                          <span
                            class="badge rounded-pill bg-success theSupPill"
                            v-if="group.is_checked == 1"
                          >
                            <i class="bi bi-check-lg"></i>
                            {{ group.name }}
                          </span>

                          <span
                            class="badge rounded-pill bg-light theSupPill"
                            style="color: black"
                            v-if="group.is_checked == 0"
                          >
                            {{ group.name }}
                          </span>
                        </div>
                        
                      </div>
                    </div>

                  </td>

                    <td>
                          <div class="theCloseBox">

                                                        <div v-if="teamStore.newGroupTalkUsersArray.length > 1">

                                                            <i @click="teamStore.deleteANewGroupTalkUserFromArray(index)"
                                                                class="bi bi-x-lg" style="cursor: pointer;"></i>

                                                        </div>


                                                    </div>
                    </td>




                

                </tr>
              </tbody> -->
            </table>

            <div class="addAnotherBox">
              <button @click="teamStore.addNewGroupTalkUserBox" class="addAnotherButton">
                + Add another user
              </button>
            </div>

            <div class="navButtonsWrapper">
              <div></div>

               <button v-if="teamStore.isAddingNewUsers" class="nextBtn" style="display: flex; width: auto;">

                                    <div class="spinner-border" role="status" style="width: 20px; height: 20px;">
                                        <span class="visually-hidden">Loading...</span>
                                    </div> 

                                    <div style="margin-left: 10px;">
                                        Processing
                                    </div>

                </button>

              <button v-else @click="teamStore.finallyAddNewGroupTalkUsers" class="nextBtn">
                Complete
              </button>
            </div>

          </div>

          <div v-else class="wizardWrapper">
              <div class="usersAddedSuccessBox">

                <div>
                    <b style="font-size: 18px; font-weight: bold;">New users added successfully!</b>
                </div>

                <div style="margin-top: 20px;">

                <button @click="$router.go(-1)" class="btn btn-dark"> View Users </button>

                </div>



                </div>
          </div>


        </div>

        <div v-if="teamStore.showEditNewGroupTalkUserToGroupModal" class="modal-overlay">
          <div class="modal-box" style="width: 700px">
            <div class="model-box-header">
              <div style="font-size: 17px">
                <b>Select Team</b>
              </div>

              <div>
                <i
                  @click="teamStore.closeEditNewGroupTalkUserToGroupModal"
                  class="bi bi-x-lg"
                  style="font-size: 20px; cursor: pointer"
                ></i>
              </div>
            </div>

            <div class="modal-search-box" style="padding: 12px">
              <input
                v-model="searchGroupName"
                type="text"
                class="form-control titleInput"
                placeholder="Search..."
              />
            </div>

            <div class="modal-content">
              <!-- {{ teamStore.currentNewUser }} -->

              <div
                class="innerBox"
                v-if="teamStore.currentNewUser && teamStore.currentNewUser.teams"
              >
                <div
                  class="talkItem"
                  v-for="(group, index) in filteredGroupNames"
                  :key="index"
                  @click="teamStore.updateCurrentGroupList(group)"
                >
                  <div class="talkLeft">
                    <div class="talkTitle">
                      {{ group.name }}
                    </div>
                  </div>

                  <div class="talkRight">
                    <div v-if="group.is_checked" class="form-check form-switch">
                      <input
                        class="form-check-input theInputSwitch"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked
                      />
                    </div>

                    <div v-else class="form-check form-switch">
                      <input
                        class="form-check-input theInputSwitch"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, ref, computed } from "vue";
import { useTeamStore } from "@/stores/TeamStore";

const teamStore = useTeamStore();

const searchGroupName = ref("");

const filteredGroupNames = computed(() => {
  return (
    teamStore.currentNewUser.teams?.filter((team) =>
      team.name.toLowerCase().includes(searchGroupName.value.toLowerCase())
    ) || []
  );
});

onMounted(() => {
  teamStore.fetchDataForAddNewGroupTalkUsersView();
 
});
</script>

<style scoped>
.mainWrapper {
  /* background-color: aliceblue; */
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.rightContentWrapper {
  /* overflow-y: auto; */
  width: 83%;
  display: flex;
  flex-direction: column;
}

.contentContainer {
  /* overflow-y: auto; */
  background-color: rgb(208, 28, 55);
  /* margin: 30px; */
  margin-top: 100px;
}

.rightColumns {
  /* display: flex;
  flex-direction: column; */
}

.topNav {
  background-color: blue;
}

.innerContainer {
  /* margin-top: 200px; */
  /* background-color: blueviolet; */
  overflow-y: auto;
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 100px;
}

.theHeaderWrapper {
  display: flex;
  justify-content: space-between;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  /* background-color: aqua; */
}

.searchBarWrapper {
  margin-top: 15px;
  width: 100%;
  padding-bottom: 20px;
  /* background-color: rgb(22, 166, 37); */
}

.theBar {
  width: 350px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
}

.button-6 {
  align-items: center;
  /* background-color: #FFFFFF; */
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  display: inline-flex;
  font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 1.25;
  margin: 0;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  width: auto;
}

.button-6:hover,
.button-6:focus {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.tableWrapper {
  margin-top: 20px;
  /* background-color: aqua; */
  width: 100%;
}

.my-custom-table tbody tr td {
  padding-top: 20px;
  /* Adjust the value as needed */
  padding-bottom: 20px;
  /* Adjust the value as needed */
}

.my-custom-table th {
  padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
  text-align: left;
  /* Aligns text to the left */
  padding-left: 20px;
  padding-right: 20px;
}

.campName {
  text-decoration: none;
  color: inherit;
}

.campName:hover {
  color: rgb(10, 159, 92);
  cursor: pointer;
  text-decoration: none;
}

.iconsRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.theActionIcon {
  font-weight: bolder;
  font-size: 18px;
  color: rgb(5, 2, 2);
  cursor: pointer;
}

.theActionIcon:hover {
  cursor: pointer;
  color: rgb(30, 158, 30);
  scale: 1.3;
  transition: 1s;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  z-index: 999;
  /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
  background-color: white;
  width: 1100px;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
  text-align: center;
}

.model-box-header {
  display: flex;
  justify-content: space-between;
  /* background-color: antiquewhite; */
  height: 40px;
  margin-bottom: 15px;
}

.form-control {
  background-color: rgb(243, 246, 246);
}

.createBTN {
  width: 100%;
  margin-top: 20px;
}

.noTeamBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
}

.noMatchBox {
  background-color: red;
  width: 100%;
}

.loadMoreBtn {
  background-color: black;
  border-radius: 10px;
}

.inviteInput {
  width: 500px;
  font-size: 13px;
  cursor: pointer;
}

.tabsWrapper {
  display: flex;
  width: 100%;
  /* background-color: #a9baba; */
}

.tabItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #fdfdfd;
  padding: 30px;
  border: 1.5px solid #c3d4cb;
  cursor: pointer;
  margin: 10px;
  border-radius: 10px;
}

.tabItem:hover {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #fdfdfd;
  padding: 30px;
  border: 1.5px solid #c3d4cb;
  cursor: pointer;
  margin: 10px;
  border-radius: 10px;
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.tabItemSelected {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  padding: 30px;
  border: 1.5px solid #c3d4cb;
  cursor: pointer;
  margin: 10px;
  border-radius: 10px;
}

.iconDrop {
  cursor: pointer;
}

.button-13 {
  background-color: #fff;
  border: 1px solid #d5d9d9;
  border-radius: 8px;
  box-shadow: rgba(213, 217, 217, 0.5) 0 2px 5px 0;
  box-sizing: border-box;
  color: #0f1111;
  cursor: pointer;
  display: inline-block;
  font-family: "Amazon Ember", sans-serif;
  font-size: 13px;
  line-height: 29px;
  padding: 0 10px 0 11px;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  min-width: 100px;
}

.button-13:hover {
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.emptyTableBox {
  margin-top: 100px;
}

.groupBtn {
  border: none;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  border-radius: 15px;
  font-size: 15px;
  margin-right: 25px;
  padding: 5px;
  padding-left: 20px;
  padding-right: 20px;
}

.groupBtn:hover {
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.theRightBox {
  display: flex;
  /* background-color: gray; */
}

.dropdown-item:hover {
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  color: black;
}

.theSearchBox {
  width: 100%;
  /* background-color: rgb(255, 136, 0); */
  padding-bottom: 20px;
}

.theTableBox {
  width: 100%;
  overflow-y: auto;
  height: 500px;
}

.addUsersBox {
  /* background-color: green; */
  width: 100%;
  padding-top: 20px;
}

.wizardWrapper {
  width: 100%;
  /* background-color: gray; */
  margin-top: 30px;
  padding: 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
}

.theFormWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* background-color: yellow; */
}

.theInputWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
}

.theInputWrapperErrorBlock {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
  background-color: pink;
  border-radius: 5px;
}

.theEmailBox {
  width: 30%;
  /* background-color: gray; */
  padding: 10px;
}

.theFirstNameBox {
  width: 20%;
  /* background-color: rgb(223, 78, 11); */
  padding: 10px;
}

.theLastNameBox {
  width: 20%;
  /* background-color: rgb(72, 215, 1); */
  padding: 10px;
}

.thePasswordBox {
  width: 30%;
  /* background-color: rgb(227, 29, 158); */
  padding: 10px;
}

.tableHeader {
  width: 100%;
  display: flex;
  /* background-color: orange; */
  text-align: left;
  font-weight: bold;
}

.thePassCont {
  display: flex;
  width: 100%;
  /* background-color: purple; */
}

.thePassInnerBox {
  width: 80%;
}

.theCloseBox {
  width: 20%;
}

.addAnotherBox {
  display: flex;
  width: 100%;
  background-color: rgb(255, 255, 255);
  padding: 10px;
}

.addAnotherButton {
  border: none;
  border-radius: 7px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  font-size: 13px;
  padding: 10px;
  font-weight: bold;
}

.addAnotherButton:hover {
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.navButtonsWrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* background-color: gray; */
  padding: 10px;
  margin-top: 20px;
}

.nextBtn {
  border: none;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  font-size: 14px;
  font-weight: bold;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100px;
}

.prevBtn {
  border: none;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  /* background: linear-gradient(90deg, #d7e0d8 0%, #d9e7ff 100%); */
  font-size: 14px;
  font-weight: bold;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100px;
}

.theSelectTeamAndSiteWrapper {
  display: flex;
  width: 100%;
  /* background-color: gray; */
}

/* .theUserNameBox,
.SelectTeamBox,
.SelectSiteBox, */

.roleBox {
  display: flex;
  width: 100%;
  /* background-color: yellow; */
}

.selectTeamBox {
  display: flex;
  width: 100%;
  background-color: rgb(226, 172, 101);
}

.nameyBoxy {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  /* background-color: green; */
}

.errorMsg {
  font-weight: bold;
  font-size: 12px;
  text-align: left;
}

.outerInputBox {
  width: 100%;
  /* background-color: yellow; */
}

.selectSupBox {
  display: flex;
  /* width: 180px; */
  width: 500px;
  border-radius: 14px;
  padding: 2px;
  /* max-height: 60px; */
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  cursor: pointer;
  background-color: #f2f2f2;
  overflow-x: auto;
}

.theSupPill {
  margin: 7px;
}

.innerBox {
  /* background-color: red; */
  overflow-y: auto;
  width: 100%;
  height: 600px;
  padding: 12px;
}

.talkItem {
  display: flex;
  flex-direction: row;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
  margin-bottom: 25px;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
}

.talkItem:hover {
  background-color: rgb(249, 253, 252);
}

.talkLeft {
  display: flex;
  flex-direction: column;
  padding: 5px;
  width: 80%;
  /* background-color: #aadada; */
}

.talkRight {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  /* padding: 10px; */
  /* background-color: #3ddbdb; */
}

.talkTitle {
  /* background-color: #d9e7ff; */
  text-align: left;
  font-weight: bold;
  padding: 6px;
}

.talkBody {
  /* background-color: #3f84fa; */
  text-align: left;
  padding-left: 5px;
  padding-bottom: 5px;
  /* margin-top: 7px; */
  /* padding: 6px; */
}

.usersInfoBox {
  font-size: 13px;
  margin-top: 20px;
  padding: 10px;
  /* width: 300px; */
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  border-radius: 10px;
  font-weight: normal;
}

.usersAddedSuccessBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* background-color: rgb(188, 186, 186); */
  padding: 30px;
}

.backlogDateCont {
  width: 100%;
  /* background-color: yellow; */
  margin-bottom: 29px;
}

.theBacklogDateInput {
  border: 2px solid red;
}

.theTableRowStyle {
  margin-bottom: 20px;
  /* background-color: green; */
}

.theTableRowStyleWithError {
  margin-bottom: 20px;
  border: 2px solid red;
}
</style>
